// extracted by mini-css-extract-plugin
module.exports = {"container":"BenefitTabContent_container__Wel7z","contentGroup":"BenefitTabContent_contentGroup__MxeGJ"};